/**
 * Counts how many times a screen has been entered. Staying on the same screen
 * keeps the same visit, coming back to it later starts a new one, which is the
 * only window where a computed tariff may be reused.
 */
export const nextScreenVisit = (previous, screenId) => {
  if (previous && previous.screenId === screenId) return previous;
  return { screenId, visit: ((previous && previous.visit) || 0) + 1 };
};
